import { render } from "./onBoardingCarousel.vue?vue&type=template&id=7e49a63e&scoped=true&ts=true"
import script from "./onBoardingCarousel.vue?vue&type=script&lang=ts"
export * from "./onBoardingCarousel.vue?vue&type=script&lang=ts"

import "./onBoardingCarousel.vue?vue&type=style&index=0&id=7e49a63e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e49a63e"]])

export default __exports__